import { PUT } from '../lib/request';

const baseUrl = `${process.env.REACT_APP_API_URL}/rest/courses`;

/**
 * Set the GAR sharing for a course
 * @param {string} courseId The course ID
 * @param {{uai: string, div: string[], gro: string[]}[]} garSharing The GAR sharing object
 * @returns {Promise<*>}
 */
export function setGarSharing(courseId, garSharing) {
  const url = `${baseUrl}/${courseId}/gar-sharing`;

  return PUT(url, { sharing: garSharing });
}
